module.exports = __webpack_public_path__ + "catalog/items/furniture/Sofa1/Sofa1.svg";